export const en = {
	'Справочный центр': 'Help Center',
	'Обучающее видео': 'Training video',
	'Наш YouTube канал →': 'Our YouTube channel →',
	'Руководства и статьи': 'Guides and articles',
	'Важные документы': 'Important documents',
	'Служба поддержки': 'Support service',
	'Работаем с 9:00 до 18:00 по Владивостоку': 'We work from 9:00 to 18:00 (UTC+10)',
	'Сейчас мы доступны': 'We are available now',
	'Сейчас мы не доступны, но вы можете оставить нам сообщение':
		'We are not available now, but you can leave us a message',

	'Презентация платформы Fishplace': 'Fishplace platform presentation',

	'Возможности платформы': 'Platform features',

	'Регистрация рыбной компании': 'Registering a fish company',

	'Регистрация холодильного склада': 'Registration of a cold storage',

	'Добавление рыбопродукции на платформу': 'Adding fish products to the platform',

	'Оформление карточки рыбопродукции': 'Registration of a fish products card',

	'Поиск склада и заявка на хранение': 'Warehouse search and storage request',

	'Подписка на рыбопродукцию': 'Subscription to fish products',

	'Цифровой офис на платформе fishplace.ru': 'Digital office on the fishplace.ru platform',

	'Политика конфиденциальности': 'Privacy policy',
	'Политика обработки персональных данных ООО «Мой Фиш Плэйс»':
		'Privacy policy of LLC "My Fish Place"',

	'Лицензионный договор': 'License agreement',
	'Лицензионный договор-оферта на право использования программы «Fishplace.ru»':
		'License agreement-offer for the right to use the program "Fishplace.ru"',

	'Пользовательское соглашение': 'User agreement',
	'Пользовательское соглашение (договор присоединения) ООО «Мой Фиш Плэйс»':
		'User agreement (accession agreement) LLC "My Fish Place"',
	'Технологический стек': 'Technological stack',
	'Средства реализации и функционирования ПО «Fishplace.ru»':
		'Development and operation tools of the "Fishplace.ru" software',

	'Руководство пользователя': 'User manual',
	'Инструкция по использованию платформы': 'Instructions for using the platform',

	'Функциональные характеристики ПО': 'Functional characteristics of the software',
	'Описание функциональных характеристик платформы':
		'Description of the functional characteristics of the platform',

	'Установка экземпляра ПО': 'Installing a copy of the software',
	'Инструкция по установке платформы': 'Platform Installation Instructions',

	'Жизненный цикл ПО': 'Software life cycle',
	'Описание процессов обеспечения жизненного цикла': 'Description of life cycle support processes',
};
